import type { Service } from '../types/content'

export const services: Service[] = [
  {
    index: '01',
    name: 'Brand & identity',
    description: 'Wordmark, palette and type system your team can apply without us.',
    to: '/services',
  },
  {
    index: '02',
    name: 'Website design',
    description: 'Editorial layouts designed screen by screen, never dragged out of a template.',
    to: '/services',
  },
  {
    index: '03',
    name: 'Development & build',
    description: 'Hand-built in Webflow, Framer or Next.js — fast on a phone with one bar.',
    to: '/services',
  },
  {
    index: '04',
    name: 'E-commerce',
    description: 'Shopify storefronts merchandised around the product, not the promotion.',
    to: '/services',
  },
  {
    index: '05',
    name: 'Care & growth',
    description: 'Monthly edits, tracking and a quarterly improvement plan after launch.',
    to: '/services',
  },
]
